import {
  LitElement,
  html,
  css,
  classMap,
  ref,
  createRef,
  map,
  range,
  unsafeHTML,
  styles,
  paths,
  utils,
  t,
} from '@hh/global.js'
const { throttle } = utils

class HHCategoryCarousel extends LitElement {
  static properties = {
    carouselSpeed: {
      type: Number,
      attribute: 'carousel-speed',
    },
    autoplay: {
      type: String,
      attribute: 'autoplay',
    },
  }

  constructor() {
    super()
    this.carouselSpeed = 0
  }

  connectedCallback() {
    super.connectedCallback()
    this.handleCarousel()
  }

  disconnectedCallback() {
    super.disconnectedCallback()
  }

  handleCarousel() {
    const splideExtension = window.splide.Extensions

    if (this.autoplay === 'true') {
      this.splide = new Splide('.js-category-carousel-slider', {
        type: 'slide',
        autoplay: this.autoplay ? 'pause' : false,
        interval: this.carouselSpeed * 1000,
        lazyLoad: 'nearby',
        preloadPages: 1,
        rewindSpeed: 1,
        intersection: {
          inView: {
            autoplay: true,
          },
        },
        arrows: true,
        pagination: false,
        perPage: 6,
        perMove: 1,
        drag: 'free',
        gap: '10px',
        mediaQuery: 'min',
        breakpoints: {
          990: {
            perPage: 6,
            padding: '1rem',
          },
          420: {
            perPage: 4,
            padding: '1rem',
          },
          300: {
            perPage: 4,
            padding: '1rem',
          },
        },
      }).mount(splideExtension)
    } else {
      this.splide = new Splide('.js-category-carousel-slider', {
        type: 'slide',
        arrows: true,
        pagination: false,
        lazyLoad: 'nearby',
        preloadPages: 1,
        rewindSpeed: 1,
        perPage: 6,
        perMove: 1,
        drag: 'free',
        mediaQuery: 'min',
        breakpoints: {
          990: {
            perPage: 6,
            padding: '1rem',
          },
          750: {
            perPage: 4,
            padding: '1rem',
          },
          300: {
            perPage: 4,
            padding: '1rem',
          },
        },
      }).mount()
    }
  }

  render() {
    return html`<slot></slot>`
  }
}

customElements.define('hh-category-carousel', HHCategoryCarousel)
